module.exports = __webpack_public_path__ + "img/isvIntroductionTechnology.a2b80fe0.png";